import { Spinner } from 'common/Spinner/Spinner'
import { Toast } from 'common/ToastMessage'
import { Button } from 'components/Button'

import Styles from 'screens/ProseEdit/components/ProcessingSuggestionToast/ProcessingSuggestionToast.module.scss'

export interface ToastProps {
  onCancel: () => void
  showCancelButton?: boolean
  text: string
}

export const ProcessingToastMessage = ({ onCancel, text, showCancelButton = false }: ToastProps) => (
  <Toast.Root variant="info">
    <Toast.Icon variant="info">
      <Spinner className={Styles.spinner} />
    </Toast.Icon>
    <Toast.Description>{text}</Toast.Description>
    {showCancelButton && (
      <Toast.Action>
        <Button className={Styles.cancelButton} onPress={onCancel} variant="secondary" size="md">
          Cancel
        </Button>
      </Toast.Action>
    )}
  </Toast.Root>
)
